import styled from 'styled-components';

export const StyledButton = styled.button<{ $wrap: boolean}>`
  position: relative;
  display: inline-block;
  text-align: center;
  border: 0;
  cursor: pointer;
  -webkit-appearance: none;
  text-decoration: none;
  outline: none;
  white-space:  ${({ $wrap }) => $wrap ? 'normal' : 'nowrap'};
  box-sizing: border-box;
`;
